import { GetterTree } from 'vuex'
import RootState from '@vue-storefront/core/types/RootState'
import SocialLoginState from '../types/SocialLoginState'

const getters: GetterTree<SocialLoginState, RootState> = {}

export default getters
